import cookiesBM from './cookies';
import imprintBM from './imprint';
import privacyBM from './privacy';
import termsBM from './termsofuse';
import otConfig from './otConfig';
import gaConfig from './ga';
import { getGAKey } from 'helpers/googleAnalitics/GAandGTM';
import getStaticUrl from 'helpers/staticContent';

const { ga: gaId, gtm } = getGAKey(gaConfig);

export default {
  ga: gaId,
  gtm,
  title: 'Microspot',
  landingImg: `${getStaticUrl()}/my-customer-space/Landing_BM.png`,
  favicon: `${getStaticUrl()}/my-customer-space/MI_favicon.ico`,
  keyLoginConfig: 'birthDate',
  langs: ['en', 'es', 'fr', 'de', 'it', 'nl'],
  defaultLang: 'en',
  faq: [
    { from: 1, to: 19, notShowed: [8, 13] },
    { from: 20, to: 28, notShowed: [21, 22, 23, 24, 25, 28] },
    { from: 29, to: 47 },
  ],
  cookies: cookiesBM,
  imprint: imprintBM,
  privacy: privacyBM,
  terms: termsBM,
  logo: {
    src: `${getStaticUrl()}/my-customer-space/Microspot_Logo.svg`,
    alt: 'Microspot',
    height: '32px',
  },
  footerlogo: {
    src: `${getStaticUrl()}/my-customer-space/Microspot_Logo.svg`,
    alt: 'Footer Microspot',
  },
  company: 'bolttech',
  otScript: otConfig,
  footer: [
    {
      label: 'terms_of_use',
      link: '/terms-of-use',
    },
    {
      label: 'imprint',
      link: '/imprint',
    },
    {
      label: 'faq',
      link: '/faq',
    },
  ],
};
